import React, { useContext } from "react";
import { ChromeNavGeneric } from "./ChromeNavGeneric";
import { ChromeAppWrapperView } from "@src/util/chrome-extension.util";
import { TranslationContext } from "@clockwise/client-commons/src/providers/TranslationContext";

type Props = {
  defaultView?: ChromeAppWrapperView;
};

export function ChromeNavAutopilotList({ defaultView }: Props) {
  const t = useContext(TranslationContext);
  return (
    <ChromeNavGeneric
      backDestination={defaultView}
      label={t("autopilot:nav-title")}
      settings
      feedback
    />
  );
}
